<template>
  <div class="appResponsiveHeight">
    <v-app id="inspire" :class="hideContainer ? 'register-container' : 'wrapper'">
      <v-app-bar app elevate-on-scroll elevation="0" :color="$vuetify.theme.dark ? '#050b13' : '#f7f9fc'"
        class="custom-navbar" v-if="!$route.meta.noSidebar">
        <v-container class="fill-height app-bar-container">
          <v-app-bar-nav-icon class="d-md-none d-sm-flex d-xl-none d-lg-none"
            @click="drawer = !drawer"></v-app-bar-nav-icon>
          <DashboardView></DashboardView>
          <audio id="notification-bell" src="sounds/notification-bell.wav" preload="auto"></audio>
          <v-spacer></v-spacer>
          <ul class="top-links-list">
            <li>
              <TradingCalculatorMenu />
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/internal-transfer" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#101925' : '#fff8df'">
                    <v-icon :color="$vuetify.theme.dark ? '#f4c515' : '#d49e00'">mdi-swap-horizontal</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Internal Transfer</span>
              </v-tooltip>
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/withdraw" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#101925' : '#fff8df'">
                    <v-icon :color="$vuetify.theme.dark ? '#f4c515' : '#d49e00'">mdi-tray-arrow-up</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Withdraw</span>
              </v-tooltip>
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/deposit" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#101925' : '#fff8df'">
                    <v-icon :color="$vuetify.theme.dark ? '#f4c515' : '#d49e00'">mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Deposit</span>
              </v-tooltip>
            </li>
          </ul>
          <PanelSwitcherView v-if="hasIbStatus"></PanelSwitcherView>
          <!-- <SignalsView></SignalsView>
          <LanguageMenu></LanguageMenu> -->
          <SwitcherView></SwitcherView>
          <NotificationView></NotificationView>
          <LogoutView></LogoutView>
        </v-container>
      </v-app-bar>
      <div :class="hideContainer ? 'container-fluid' : 'custom-container'">
        <v-row no-gutters>
          <v-col xl="2" class="custom-width-navigation-drawer" v-if="!$route.meta.noSidebar">
            <div class="navigation-drawer-container">
              <v-navigation-drawer v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp" width="240"
                class="navigation-drawer sidebar-navigation-drawer"
                :color="$vuetify.theme.dark ? '#07111d' : '#E8F1F8'">
                <AdminLogo></AdminLogo>
                <AllMenu></AllMenu>
              </v-navigation-drawer>
              <HelpAssistantWidget v-if="!$route.meta.noSidebar" />
            </div>
          </v-col>
          <v-col class="custom-width-main registration-page">
            <v-main>
              <router-view></router-view>
              <!--WhatsApp Floating Button -->
              <!--<a href="https://wa.me/971525622077?text=Hello%20I%20need%20help" target="_blank" class="whatsapp-btn"
                title="Chat on WhatsApp">
                <v-icon color="white" size="28">mdi-whatsapp</v-icon>
              </a>
              -->
            </v-main>
          </v-col>
        </v-row>
      </div>
    </v-app>
  </div>
</template>

<script>
import AdminLogo from "./components/SideBar/AdminLogo.vue";
import AllMenu from "./components/SideBar/AllMenu.vue";
import DashboardView from "./components/TopBar/DashboardView.vue";
import LanguageMenu from "./components/TopBar/LanguageMenu.vue";
import LogoutView from "./components/TopBar/LogoutView.vue";
import NotificationView from "./components/TopBar/NotificationView.vue";
import PanelSwitcherView from "./components/TopBar/PanelSwitcherView.vue";
import SignalsView from "./components/TopBar/SignalsView.vue";
import SwitcherView from "./components/TopBar/SwitcherView.vue";
import TradingCalculatorMenu from "./components/TopBar/TradingCalculatorMenu.vue";
import HelpAssistantWidget from "./components/assistant/HelpAssistantWidget.vue";
import { mapActions, mapState } from "vuex";
import { PROFILE__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      drawer: null,
    };
  },

  components: {
    LanguageMenu,
    NotificationView,
    SignalsView,
    SwitcherView,
    DashboardView,
    LogoutView,
    AdminLogo,
    AllMenu,
    PanelSwitcherView,
    TradingCalculatorMenu,
    HelpAssistantWidget,
  },

  watch: {
    token: {
      handler(token) {
        if (token) {
          this[PROFILE__ACTIONS.GETPROFILE]();
        }
      },
      immediate: true,
    },
    client: {
      handler(val) {
        if (val && val.theme_preference !== undefined) {
          this.$vuetify.theme.dark = val.theme_preference === 1;
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState("profile", ["client"]),
    ...mapState("authentication", ["token"]),

    hideContainer() {
      return (
        this.$route.name === "/" ||
        this.$route.name === "Login" ||
        this.$route.name === "CreateAccount" ||
        this.$route.name === "Registration" ||
        this.$route.name === "SendOtp" ||
        this.$route.name === "ForgotPassword"
      );
    },

    hasIbStatus() {
      return this.$store.state.authentication.ib_status === 1;
    }
  },

  methods: {
    ...mapActions("profile", ["GETPROFILE"]),
  },

};
</script>

<style scoped>
.appResponsiveHeight {
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}

/* ✅ Floating WhatsApp button fixed to bottom-right */
@media (max-width: 599.98px) {
  .custom-navbar ::v-deep .v-toolbar__content {
    height: 56px !important;
    padding: 0 8px !important;
  }

  .custom-navbar ::v-deep .app-bar-container {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    width: 100% !important;
    min-width: 0;
    height: 56px;
    padding: 0 !important;
    overflow: visible;
  }

  .custom-navbar ::v-deep .v-toolbar__title {
    display: none !important;
  }

  .custom-navbar ::v-deep .v-app-bar__nav-icon,
  .custom-navbar ::v-deep .notification-btn {
    flex: 0 0 38px !important;
    width: 38px !important;
    min-width: 38px !important;
    height: 38px !important;
    margin: 0 1px !important;
  }

  .custom-navbar ::v-deep .top-links-list {
    flex: 0 0 auto;
    margin: 0 !important;
  }
}

.whatsapp-btn {
  position: fixed !important;
  bottom: 50px !important;
  right: 35px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  background-color: #25d366;
  border-radius: 50%;
  text-decoration: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  z-index: 9999;
  /* ensures it stays above everything */
}

.whatsapp-btn:hover {
  background-color: #1ebe5d;
  transform: scale(1.1);
}
</style>
